// extracted by mini-css-extract-plugin
export default {"center":"Layout_center__KCgLz","layout":"Layout_layout__EUeMs"};